export default __webpack_public_path__ + "static/12-550745a843aca6b3e3101d86961a7222.jpg";